<template>
  <div class="dataloggerManage">
    <div class="section">
      <div class="search">
        <!-- {{$t('datalogger.Datalogger_Status')+'：'}} -->
        <!-- 下拉筛选框(占位) -->
        <!-- <el-select></el-select> -->
        <div></div>

        <div sytle="display:flex;justify-contentflex-end;">
          <!-- 搜索 -->
          <!-- showSearch = true; -->
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <!-- v-clickoutside="closeSearch2" -->
          <div class="search-alert" v-show="showSearch">
            <!-- :placeholder="$t('recharge.pn')" -->
            <!-- v-model="inputText" -->
            <!-- @input实时查询 -->
            <!-- @keyup.enter.native -->
            <div class="searchDiv">
              <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search" @keyup.enter.native="getProjectList(true)"
                :placeholder="this.$t('project.projectName')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="getProjectList(true)">{{ $t('recharge.Search') }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
            </div>
          </div>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <!-- v-show="showBatch" -->
        <!-- v-show="selectedplant.length" -->
        <!-- v-show="false" -->
        <div class="batch-alert" v-show="false">
          <!-- 当前选中条数 -->
          <span class="batch-total">
            {{ `${$t('alarm.curSelected')} ${selectedplant.length} ${$t('alarm._Data')}` }}
          </span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 导出 -->
              <!-- <span 
                class="btn"
                @click="exportPlant(selectedplant)"
              >
                {{$t('report.Export')}}
                <i class="ico ico-export"></i>
              </span> -->
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{ $t('rate.cancel') }}</span>
          </div>
        </div>
      </div>
      <el-table :data="proList" stripe border height="100%" v-loading="loadingProject"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" element-loading-spinner="el-icon-loading"
        @selection-change="changeFun" class="tablemain tableloding" :empty-text="$t('account.nodata')"
        ref="multipleProTable">
        <!-- <el-table-column fixed type="selection"></el-table-column> -->
        <!-- 项目名称 -->
        <el-table-column min-width="140px;" fixed :show-overflow-tooltip="true" :label="this.$t('project.projectName')">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            <!-- @click="previewDatalogger(scope.row)" -->
            <!-- pname -->
            <span class="redirect" @click="enterProject(scope.row)" :title="scope.name">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <!-- 项目ID -->
        <el-table-column prop="pid" min-width="135px;" :show-overflow-tooltip="true"
          :label="this.$t('project.projectId')"></el-table-column>
        <!-- 所属用户 -->
        <el-table-column prop="usr" min-width="135px;" :show-overflow-tooltip="true"
          :label="this.$t('device.User_belong')"></el-table-column>

        <!-- 项目描述(新增) -->

        <!-- 当前功率 -->
        <!-- <el-table-column
          prop="energy"
          min-width="135px;"
          :show-overflow-tooltip="true"
          :label="this.$t('project.energyCurrent')"
        ></el-table-column> -->
        <!-- 当日发电量(kWh) -->
        <el-table-column prop="energy" min-width="135px;" :show-overflow-tooltip="true"
          :label="`${this.$t('project.energyDate')} (kWh)`"></el-table-column>
        <!-- 当月发电量(kWh) -->
        <el-table-column prop="energyMonth" min-width="135px;" :show-overflow-tooltip="true"
          :label="`${this.$t('project.energyMonth')} (kWh)`"></el-table-column>
        <!-- 当年发电量(kWh) -->
        <el-table-column prop="energyYear" min-width="135px;" :show-overflow-tooltip="true"
          :label="`${this.$t('project.energyYear')} (kWh)`"></el-table-column>
        <!-- 总发电量(kWh) -->
        <el-table-column prop="energyTotal" min-width="135px;" :show-overflow-tooltip="true"
          :label="`${this.$t('project.energyTotal')} (kWh)`"></el-table-column>

        <!-- 操作 -->
        <!-- 导出项目报表(该期暂时注释) -->
        <!-- <el-table-column :label="this.$t('datalogger.Operation')" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('datalogger.edit')"
							@click="editDatalogger(scope.row)"
            >
              <i class="iconfont icon-bianji"></i>
            </el-button>
          </template>
        </el-table-column> -->
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty">
          <img src="@/assets/img/empty_text.png" />
          <div style="line-height: 32px">{{$t('account.nodata')}}</div>
        </div> -->
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div class="" style="margin-left:10px;"></div>
        <!-- 分页 -->
        <!-- v-show="paginationControl" -->
        <el-pagination class="pagination" background @size-change="getProjectList(true)"
          @current-change="() => getProjectList()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗系列 -->
  </div>
</template>
<script>
// import exportPlantDialog from "@/components/dialognew/exportPlant";
export default {
  components: {
    // exportPlantDialog,
  },
  data () {
    return {
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      // 项目列表分页加载
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0,
      },
      // 项目加载加载
      loadingProject: false,
      // 搜索弹出
      showSearch: false,
      // 搜索
      search: {
        search: "",
      },
      //勾选项目导出
      selectedplant: [],
      // 项目列表
      proList: [],
    };
  },
  watch: {
    // 响应更新电站列表事件
    // "$store.state.event.updateDataloggerList"(val) {
    //   if (val) {
    //     this.getProjectList();
    //     this.$store.state.event.updateDataloggerList = false;
    //   }
    // },
    // upgradeDataloggerVisible(val) {
    //   if (!val) {
    //     clearInterval(this.interval);
    //     this.interval = null;
    //     this.progressUp = false;
    //   }
    // },
  },
  created () {
    this.getProjectList();
  },
  methods: {
    //勾选多项
    changeFun (val) {
      this.selectedplant = val; // 返回的是选中的列的数组集合
    },
    // 导出报表
    // exportPlant(exportPlantParams) {
    //   if (!exportPlantParams.length) return false;
    //   this.exportPlantParams = exportPlantParams;
    // },
    //获取项目列表数据(新接口queryPlantsInfoEs返回字段少)=====
    // getProjectList(reset) {
    //   // this.paginationControl = false;
    //   if (reset) this.pagination.currentPage = 1;
    //   let param = {
    //     // page: 0,
    //     // pagesize: this.paginationPro.pagesize,
    //     page: this.pagination.currentPage - 1,
    //     pagesize: this.pagination.pagesize,
    //     devtype: 2304,
    //     plantName: this.search.search,
    //     // ...this.search,
    //   };
    //   this.loadingProject = true;
    //   // queryPlantsInfoEs => queryPlantCollDevEs
    //   this.$request.get("queryPlantsInfoEs", param).then(res => {
    //     // console.log("【adminNew-device->queryPlantsInfoEs】");
    //     if (res.err == 0) {
    //       // console.log("项目列表", res.dat);

    //       // 赋值
    //       this.proList = res.dat.info;
    // 			this.pagination.total = res.dat.total;
    //       this.loadingProject = false;
    //     } else {
    //       // this.$message.warning(this.$t(`errCode.${res.err}`));
    //       // 赋值
    //       this.proList = [];
    // 			this.pagination.total = 0;
    //       this.loadingProject = false;
    //     }
    //   });
    // },
    //获取项目列表数据(新接口queryPlantsInfoEs返回字段多)=====
    getProjectList (reset) {
      // this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // page: 0,
        // pagesize: this.paginationPro.pagesize,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        devtype: 2304,
        plantName: this.search.search,
        // ...this.search,
        // ---------------
        // usr: "",
        // orderBy: ascInstall,
        // i18n: zh_CN,
      };
      this.loadingProject = true;
      // webQueryPlants
      this.$request.get("webQueryPlants", param).then(res => {
        if (res.err == 0) {
          // console.log("项目列表", res);

          // 赋值
          this.proList = res.dat.plant;
          if (this.$store.state.user.producercode == '08'|| this.$store.state.user.dealerVcode == '08') {
            this.proList.forEach(item => {
              item.energy=Number(item.energy).toFixed(3)
              item.energyDate=Number(item.energyDate).toFixed(3)
              item.energyMonth=Number(item.energyMonth).toFixed(3)
              item.energyTotal=Number(item.energyTotal).toFixed(3)
              item.energyYear=Number(item.energyYear).toFixed(3)
            })
          }
          this.pagination.total = res.dat.total;
          this.loadingProject = false;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          // 赋值
          this.proList = [];
          this.pagination.total = 0;
          this.loadingProject = false;
        }
      });
    },
    // 点击进入项目(跳转)
    enterProject (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('project_access')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      // console.log("redirect=》");
      // console.log("redirect=》info", info);

      // this.$store.commit("saveDeviceInfo", {
      //   pn: info.pn, //
      //   sn: info.sn, //
      //   devaddr: info.devaddr, //
      //   devcode: info.devcode, //
      //   status: info.status, //
      //   devalias: info.devalias, //
      //   pid: info.pid, //
      //   focus: info.focus, //
      //   usr: info.usr, //
      //   uid: info.uid, //
      // });
      // 通知显示设备信息页(隐藏table)
      // this.$emit('noticeSingleBox', true);

      if (!info.uid) {
        // 提示(无所属用户，无权限查看)
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            // 保存管理员要跳转普通用户查看项目ID
            // this.$store.commit("savePlantidCurTo", {
            //   plantidCurTo: info.pid, //
            // });

            // console.log('管理员进入设备', res.dat)
            let routeUrl = this.$router.resolve({
              // path: toPath,
              // path: "/general/home",
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                // 传递项目ID和名称
                pid: info.pid,
                pname: info.pname,
              }
            });

            // console.log('routeUrl', routeUrl)

            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.search = '';
      this.getProjectList();
    },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    },
    // 关闭批量操作弹条
    closeBatch () {
      this.$refs.multipleProTable.clearSelection();
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  .redirect {
    color: @primaryTextColor;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        // width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .searchAll {
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .batch-alert {
        height: 48px;
        line-height: 48px;
      }

      // 添加数采器
      .button-addscq {
        // width: 114px;
        height: 48px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        cursor: pointer;

        span {
          font-size: 14px;
        }

        i {
          margin-left: 10px;
        }
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      // 表格右侧边线
      // /deep/.el-table--border::after, 
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  // 设备调试返回值
  .debug-return {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 6px 8px;
    background: rgba(43, 56, 66, 1);

    /deep/.el-textarea__inner {
      border: none;
      background: rgba(43, 56, 66, 1);
    }

    .return-tool {
      border-top: 1px dashed rgba(204, 206, 221, 0.5);
      text-align: right;
      padding: 6px 10px 0px;
      margin-top: 5px;

      .btn:hover {
        color: @primaryTextColor;

        .ico-clear {
          background: url(../../../assets/img/general/Icon_Debug_Delete_Dark.png);
        }

        .ico-copy {
          background: url(../../../assets/img/general/Icon_Debug_Copy_Dark.png);
        }
      }

      .btn {
        padding: 0px;
        color: rgba(235, 235, 235, 1);
        font-size: 12px;
        cursor: pointer;
      }

      .ico-clear {
        background: url(../../../assets/img/general/Icon_Debug_Delete.png);
      }

      .ico-copy {
        background: url(../../../assets/img/general/Icon_Debug_Copy.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
      }
    }
  }

  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 数采器下设备列表
  .datalogger-device {

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }

    /deep/.el-table__row.el-table__row--striped td {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }

    /deep/.el-table__body-wrapper,
    .el-table__footer-wrapper,
    /deep/.el-table__header-wrapper {
      background: rgba(34, 45, 53, 1);
      color: rgba(235, 235, 235, 1);
    }
  }

  // 数采器对应设备
  .viewDevice {
    // border: none;
    border-top: 1px solid #A3A9B5;

    /deep/.el-table th,
    /deep/.el-table tr {
      border: 1px solid #A3A9B5;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      border-color: #A3A9B5;
    }

    /deep/.el-table__body,
    /deep/.el-table__footer,
    /deep/.el-table__header {
      border-left: none;
      border-right: none;
    }

    /deep/.el-table__empty-block {
      background: #222d35;
    }

    // .el-table__body, 
    // .el-table__footer, 
    // .el-table__header {
    //   // table-layout: auto;
    //   // border-left: 1px solid #A3A9B5;
    //   // border-right: 1px solid #A3A9B5;
    // }
  }

  // 固件升级状态窗
  .upgradeNew {

    .processstatue,
    .processstatueEquipment {
      font-size: 16px;
      color: #16D09A;
    }

    /deep/.el-progress__text {
      color: #ffffff;
    }

    .progerssComplete,
    .progerssCompleteEquipment {
      background: transparent;
    }

    .progerssComplete {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: 0px;
      align-items: flex-start;

      .progressName {
        margin-left: 0px;
      }
    }
  }

  // 批量操作弹条
  .batch-alert {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    z-index: 1;
    background: rgba(255, 231, 107, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .batch-total {
      padding-left: 16px;
      font-size: 14px;
    }

    .batch-right {
      display: flex;
      justify-content: flex-end;
    }

    .batch-hide {
      height: 48px;
      line-height: 48px;
      padding: 0px 16px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 1);
      }
    }

    .batch-operate {
      display: flex;
      justify-content: flex-end;

      .btn {
        color: rgba(34, 45, 53, 1);
        font-size: 14px;
        cursor: pointer;
        // display: inline-block;
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        border-radius: 0px;
        display: flex;
        align-items: center;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .ico-copy {
        background: url(../../../assets/img/general/Icon_Batch_Copy.png);
      }

      .ico-export {
        background: url(../../../assets/img/general/Icon_Batch_Export.png);
      }

      .ico-clear {
        background: url(../../../assets/img/general/Icon_Batch_Delete.png);
      }

      .ico-upgrade {
        background: url(../../../assets/img/general/Icon_Batch_Upgrade.png);
      }

      .ico-more {
        background: url(../../../assets/img/general/Icon_Batch_More.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 8px;
      }

      // 批量更多下拉 (不可scoped)(.dropdown-more)
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {

  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00FEBB;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00FEBB;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00FEBB;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7B8395;
  }

  .el-month-table td .cell:hover {
    color: #00FEBB;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00FEBB;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7B8395;
  }

  .el-year-table td .cell:hover {
    color: #00FEBB;
  }
}

// 表格右侧边线
// .dataloggerManage {
//   .el-table--border::after, 
//   .el-table--group::after {
//     display: none;
//   }
// }
.tablemain.el-table--border::after {
  display: none;
}

.dataloggerManage {
  .scqsbAlert {

    .el-table--border::after,
    .el-table--group::after {
      display: block;
      background-color: #A3A9B5;
    }

    // 弹窗表格右侧边线
    .el-table--border {
      border-right: 1px solid #A3A9B5;
    }

    // 滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }

    // 加载数据时遮罩
    .el-loading-mask {
      background-color: transparent;
    }

    .el-loading-spinner i {
      color: @primaryTextColor;
    }
  }
}
</style>
